/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Translation file for French language
 *
 * @file fr.js
 * @author Manimaran.S
 */

const fr = {
  'popularChannelSlider.allChannels': 'Tous les canaux',
  'popularChannelSlider.recommended': 'Recommandé',
  'hero.myetextbook.link': 'de livres électroniques',
  'hero.myetextbook.text': 'Ce n’est pas le bon titre ? Accédez à votre bibliothèque',
  'hero.etextfeaturestitle': 'Trouvez votre matériel d’étude dans votre livre électronique',
  'hero.etextfeaturesdescription': 'Votre livre électronique est fourni avec du matériel d’étude conçu pour vous aider à bien réussir. Étudiez avec des cartes-mémoires et autres supports dans votre livre électronique.',
  'aichat.title1': 'Obtenez de l’aide générée par l’intelligence artificielle en rapport avec ce livre électronique.',
  'aichat.chatDesc1': 'Saisissez une question pour démarrer',
  'subscriptiontext.isSubscribed': 'Partie de votre abonnement',
  'subscriptiontext.nonSubscriber': 'Mettez à jour pour obtenir un accès complet',
  'topicConatiner.otherHeader': 'Vidéos et exercices associés',
  'topicConatiner.exactLiteHeader': 'Concepts et exercices associés',
  'moremenu.downloadApp': 'Télécharger l’application',
  'moremenu.downloadAppAlreadyDownload': '%Click here% pour télécharger l’application sur un autre appareil et vous connecter automatiquement ou pour utiliser votre code QR unique afin de vous connecter en toute sécurité sur l’application que vous avez déjà installée.',
  'moremenu.downloadAppNotDownload': '%Click here% pour télécharger l’application et vous connecter en toute sécurité avec votre code QR unique.',
  'channel.noBundletitle': 'Utilisez Préparation à l’étude pour vos cours connexes et autres cours',
  'onboard.studyPlan': 'Plan d’étude personnalisé créé !',
  'onboard.addCourseAnother': 'Voulez-vous ajouter un autre cours ?',
  'onboard.purchase': 'J\'ai besoin d\'acheter un eTextbook de Pearson',
  'onboard.addCourseWithoutEtext': 'Ajouter un cours via Préparation aux études',
  'onboard.mayBeLater': 'Peut-être plus tard',
  'onboard.aboutCourse': 'Parlez-nous de votre cours',
  'onboard.close': 'Fermer',
  'course.addTitle': 'Ajouter un cours',
  'common.PURCHASE': 'Acheter',
  'common.CLOSE': 'Fermer',
  'open': 'ouvrir',
  'continue': 'Continuer',
  'yes': 'Oui',
  'no': 'Non',
  'audio': 'Audio',
  'courses.toc.PUBLISH_SUCCESS': 'Succès!',
  'courses.toc.PUBLISH_MESSAGE': 'Les étudiants verront vos modifications la prochaine fois quils ouvriront du contenu.',
  'errors.GENERIC_TITLE': 'Vous n’avez pas accès pour le moment',
  'errors.GENERIC_DESC': 'Commencez par actualiser la page ou vider votre cache. Si cela ne fonctionne pas, contactez ',
  'errors.GENERIC_LINK': 'l’assistance Pearson.',
  'errors.GENERIC_CODE': 'Code d’erreur : {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Abonnement introuvable',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Votre compte ne permet pas l\\\'accès à ce titre. Si vous pensez avoir reçu ce message par erreur veuillez contacter le support technique.',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Abonnement introuvable',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Votre abonnement n\'inclut pas l\'accès au eText, mais vous pouvez l\'obtenir dès maintenant en utilisant une carte de crédit.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://pearsonerpi.com/aide',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'My account (Mon compte)',
  'menu.helpCenter': 'Centre d\'appels',
  'menu.preferencesCenter': 'Centre de préférences',
  'menu.CONTACT_SUPPORT': 'Contacter l"assistance',
  'menu.HELP_SUPPORT': 'Aide et support technique',
  'menu.FAQS': 'FOIRE AUX QUESTIONS',
  'menu.CHAT_WITH_SUPPORT': 'Discutez avec l\'assistance technique',
  'menu.OTP_CODES': 'Codes OTP',
  'menu.LAUNCH_CODE': 'Lancer le journal de code',
  'menu.SEND_CODE': 'Envoyer un nouveau code d\'utilisateur par e-mail',
  'menu.SEND_CODE_PHONE': 'Envoyer un nouveau code d\'utilisateur par SMS',
  'menu.LEGAL': 'Département juridique',
  'menu.PRIVACY_NOTICE': 'Avis de confidentialité',
  'menu.TITLE_INFO': 'Info Titre',
  'menu.PEARSON_ACCESSIBILITY': 'Accessibilité Pearson',
  'menu.DEVICE_WARNING_MESSAGE': 'Enregistrez {deviceLimit} appareils. Échangez-les 1 par mois.',
  'menu.ACCESSIBILITY': 'Accessibilité',
  'menu.ACCESSIBILITY_SUPPORT': 'Soutien à l\'accessibilité',
  'menu.DEVICES': 'Récent appareils',
  'menu.THIS_DEVICE': 'Cet appareil',
  'menu.GET_THE_APP_DOWNLOAD': 'Télécharger l\'application mobile',
  'menu.MOJO_APP_INFO': 'Rendez-vous dans l\'App Store sur votre téléphone ou votre tablette pour utiliser Pearson+ hors ligne.',
  'menu.DEVICE_LABEL': 'Appareil',
  'menu.DEVICE_DISCONNECT': 'Déconnecter',
  'menu.FOXIT': 'Optimisé par FoxIT',
  'menu.TERMS_OF_USE': 'Conditions d\'utilisation',
  'menu.SIGN_OUT': 'Se déconnecter',
  'menu.PRINT_PAGE': 'Imprimer la page',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. Tous droits réservés.',
  'print.FOOTER_MESSAGE': 'Imprimé par {fullName}({email}) le {currentDate}.',
  'print.WATERMARK': 'Droit d\'auteur © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Vous avez déjà échangé ce mois-ci',
  'device.SWITCH_DEVICE': 'Passer à l\'appareil actuel ?',
  'device.SWITCH_ONCE': 'Puisque vous ne pouvez changer qu\'une fois par mois, vous ne pourrez pas annuler cette action.',
  'device.SEAT_TAKEN': 'Ce siège est pris',
  'device.DISCONNECT_DEVICE': 'Vous ne pouvez vous connecter qu\'à 3 appareils. Pour continuer ici, débranchez un autre appareil.',
  'device.ALERT_TEXT': 'N\'oubliez pas que vous ne pouvez échanger des appareils qu\'une fois par mois.',
  'device.DISCONNECT': 'Déconnecter',
  'device.CONTINUE': 'Continuer',
  'device.HEADER': 'Terminer la session ouverte sur un autre navigateur ?',
  'device.CLOSE': 'Retour à l\'accueil',
  'device.CODE': 'Continuez ici en saisissant le code d’authentification envoyé à {maskedEmail}. Cela ne fonctionne pas ? Vérifiez votre dossier de courrier indésirable, {email} ou contactez {support}.',
  'device.TIMER': 'Vous avez {time} pour saisir votre code ici',
  'device.RESEND': '{resend}',
  'device.FAQ': 'FAQ',
  'device.RESEND_NAME': 'Renvoyer',
  'device.NOTE': 'Si vous utilisez régulièrement Pearson+ à 2 endroits, par exemple au travail et à la maison, veillez à vous déconnecter lorsque vous avez terminé. Vous pouvez également utiliser l’application mobile Pearson+ sur jusqu’à 2 appareils. Pour en savoir plus, consultez notre {faq}.',
  'device.NOTE_HEADER': 'Éviter cela la prochaine fois',
  'device.CONTACT_SUPPORT': 'support client',
  'device.CONTACT_EMAIL': 'mettre à jour votre adresse email',
  'device.INCORRECT': 'Erreur : vérifiez votre code ou renvoyez-le.',
  'device.MANY_ATTEMPTS': 'Trop de tentatives, essayez de renvoyer le code',
  'device.EXPIRED': 'Votre temps est écoulé, essayez de renvoyer le code',
  'device.ACCESS_HEADER': 'Vous vous êtes connecté !',
  'device.ACCESS_DESC': 'Votre session a été authentifiée. Vous voulez mettre à jour votre mot de passe pendant que vous y êtes ?',
  'device.ACCESS_CHANGE_PASSWORD': 'Modifier le mot de passe',
  'device.ACCESS_RESET_PASSWORD': 'Réinitialiser le mot de passe',
  'device.THREATONE_TITLE': 'Tout va bien ?',
  'device.THREATONE_DESC': 'Nous avons remarqué une activité suspecte sur votre compte.',
  'device.THREATONE_DESC_TWO': 'C\'est le bon moment pour changer de mot de passe.',
  'device.MAY_BE_LATER': 'Peut-être plus tard',
  'device.OKAY': 'OK',
  'device.ACCOUNT_LOCK_DESC': 'Pour assurer votre sécurité, nous vous déconnectons. Nous avons envoyé un lien de réinitialisation de mot de passe à l\'e-mail associé à votre compte.',
  'device.ACCOUNT_LOCK_TITLE': 'Nous avons remarqué une activité suspecte sur votre compte',
  'device.ACCOUNT_LOCK_TIMER': 'Vous serez déconnecté dans {time}',
  'navigation.PAGE': 'Page',
  'launchcode.CREATEBY': 'Créé par :',
  'launchcode.sentvia': 'Envoyé via:',
  'launchcode.CODEINLAST': 'Codes des 7 derniers jours :',
  'launchcode.TIMESENT': 'Heure d\'envoi :',
  'launchcode.ACCOUNTEMAIL': 'E-mail du compte :',
  'launchcode.LAUNCHDIALOGTITLE': 'Journal de code OTP',
  'textmessage.TITLE': 'Entrer un numéro de téléphone',
  'textmessage.PHONE_NUMBER': 'Numéro de téléphone',
  'textmessage.SEND_CODE': 'Envoyer un code',
  'textmessage.INVALID_NUMBER': 'Numéro de téléphone invalide.',
  'textmessage.SUCCESS_MESSAGE': 'Code envoyé',
  'remove.title': 'Supprimer le titre ?',
  'remove.subTitle': 'Vous pouvez toujours le récupérer plus tard - il suffit d\'utiliser la recherche pour l\'ajouter à nouveau.',
  'remove.buttonText': 'Supprimer',
  'search.searchPlaceHolderPPlus': 'Recherchez par ISBN, Titre, ou Auteur',
  'search.searchPlaceHolderEText': 'Recherchez votre bibliothèque',
  'footer.downloadMobileApp': 'Télécharger l\'application mobile',
  'footer.termsOfUse': 'Conditions d\'utilisation',
  'footer.privacy': 'Confidentialité',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Ne pas vendre mes informations personnelles',
  'footer.accessibility': 'Accessibilité',
  'footer.patentNotice': 'Avis de brevet',
  'footer.copyrights': 'Pearson Tous droits réservés.',
  'hero.toc.defaultPlacehoder': '--- sélectionner un sujet ---',
  'hero.openEtextBookV1': 'Ouvrir un eTextbook',
  'hero.heroHeading': 'Parce que vous étudiez <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Préparation aux études',
  'hero.study.help': 'Obtenez une aide à l\'étude',
  'hero.study.jumpBackIn': 'Revenir en arrière',
  'hero.study.numOfUsers': 'Actuellement, <b>{num_of_users}</b> étudiants utilisent les Canaux.',
  'hero.heroChannel.cardsHeading': 'Poursuivez là où vous vous êtes arrêté',
  'hero.marketingcard1.copy.title': 'Apprenez avec des vidéos',
  'hero.marketingcard1.copy.description': 'Regardez des vidéos d’explication qui décomposent les sujets délicats.',
  'hero.marketingcard2.copy.title': 'Entraînez-vous aux problèmes',
  'hero.marketingcard2.copy.description': 'Préparez votre examen avec des milliers de questions similaires à celles de l\'examen et des solutions vidéo',
  'hero.marketingcard3.copy.title': 'Obtenez une aide expérimentée',
  'hero.marketingcard3.copy.description': 'Posez des questions et obtenez des réponses d’experts en la matière.',
  'hero.popularTopics.heading': 'Autres sujets populaires sur ce Canal',
  'hero.popularChannels.headingv1': 'Vous désirez suivre un autre cours ?',
  'hero.popularChannels.descriptionv2': 'Passez en revue les sujets d\'aide à l\'étude les plus populaires.',
  'hero.practice': 'Pratique',
  'hero.herobook.mappedChannelHeading': 'Aide à l\'étude recommandée sur ce Canal',
  'libraryL2.myBooks': 'Mes livres',
  'libraryL2.archived': 'Archivé',
  'libraryL2.back': 'Retour',
  'hero.practiceProblem': 'Problème pratique',
  'nativeAppBanner.drawer.title': 'Ouvrir dans …',
  'nativeAppBanner.drawer.pearsonApp': 'Application Pearson+',
  'nativeAppBanner.banner.title': 'Application Pearson+',
  'nativeAppBanner.banner.description': 'Apprenez où que vous soyez',
  'hero.promotionalcard.list1': 'Des petites vidéos qui décomposent les sujets délicats.',
  'hero.promotionalcard.list2': 'Des milliers de questions similaires à celles de l’examen',
  'hero.promotionalcard.list3': 'Obtenez des réponses d’experts en la matière',
  'hero.studyandexamprep': 'Préparation aux études',
  'hero.heroBook.sectionSubHeadingV1': 'Décomposez les sujets difficiles avec des explications vidéo et des questions pratiques et adaptées à votre cours.',
  'hero.heroBook.sectionSubHeadingV2': 'Décomposez les sujets difficiles avec des explications sur les concepts et des questions pratiques et adaptées à votre cours.',
  'hero.SeeAllStudyOptions': 'Voir toutes les options d’étude',
  'hero.herobook.mappedChannelHeadingV1': 'Vidéos et questions d’entraînement recommandées',
  'hero.popularTopics.headingV1': 'Autres thèmes populaires',
  'hero.heroHeadingV1': 'Pour <span>{replace_value}</span>',
  'hero.learnmore': 'En apprendre davantage',
  'hero.eTextbook': 'eTextbook',
  'hero.goToPage.label': 'Accéder à la page',
  'subscription.studyTitle': 'Préparation aux études',
  'print.printAvailTitle': 'Vous voulez imprimer cette page ? Voici comment',
  'print.printAvailDesc': 'Dans votre livre électronique, sélectionnez l’icône du compte située dans le coin supérieur droit. Depuis les options, choisissez « Imprimer la page », puis définissez vos paramètres d’impression.',
  'print.printNotAvailTitle': 'L’option d’impression n’est pas activée pour cet eText.',
  'print.printNotAvailDesc': 'Pour un accès hors ligne pratique, veuillez télécharger votre titre via l’application mobile Pearson+ et profitez de la flexibilité d’étudier n’importe où, n’importe quand !',
  'hero.header.cta': 'Accéder aux outils d’étude',
  'hero.header.ctav2': 'Ouvrir Préparation à l’étude',
  'hero.marketing.title': 'Trouvez votre eTextbook',
  'hero.marketing.subTitle': 'Choisissez parmi plus de 2 000 livres électroniques avec des fichiers audio, des flashcards, des notes et bien plus encore. Pour seulement 10,99 $/mois pendant 4 mois.',
  'hero.popularchannels.desc': 'Obtenez de l’aide pour vos révisions avec ces sujets de haut niveau.',
  'hero.removecourse.title': 'Supprimer le cours du Tableau de bord ?',
  'hero.removecourse.description': 'Vous pouvez toujours ajouter ce cours à votre tableau de bord en cliquant sur « Ajouter un cours ».',
  'hero.removecourse.primaryCtaText': 'Supprimer',
  'hero.removecourse.secondaryCtaText': 'ANNULER',
  'hero.tableOfContents': 'Sommaire',
  'hero.search': 'Rechercher',
  'hero.emptystate.cta': 'Rechercher des livres électroniques',
  'hero.watch_it_again': 'Regarder à nouveau',
  'hero.mondly.learnLang.title': 'Apprendre une nouvelle langue gratuitement',
  'hero.mondly.subTitle': 'Les utilisateurs du livre électronique de Pearson bénéficient de trois mois gratuits de Mondly by Pearson.',
  'hero.mondly.description': 'La majeure partie des applications d’apprentissage des langues ne vous permettent d’apprendre qu’en anglais. Pourtant, il est préférable d’apprendre dans votre langue maternelle. Mondly vous permet d’apprendre dans n’importe laquelle de nos 41 langues.',
  'hero.mondly.startLearningCTA': 'Commencer à apprendre',
  'hero.mondly.marketing.bestApp': 'Meilleure application',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Application de l’année',
  'hero.mondly.marketing.fbStart': 'Lauréat Facebook FbStart 2017 – EMEA',
  'hero.mondly.marketing.editorChoice': 'Choix de la rédaction',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Apprendre une langue',
  'header.menu.moreAtPearson': 'Plus chez Pearson',
  'hero.subscriptionStatusTitle2': 'Vos ressources Pearson+',
  'hero.startStudying': 'Commencer l’étude',
  'onboard.studyMaterials': 'Choisissez votre matière et nous créerons un tableau de bord avec du matériel d\'étude personnalisé.',
  'hero.myETextbooks': 'Mes eTextbooks',
  'header.continueInTheApp': 'Continuer sur l’application',
  'hero.learnTxt': 'Apprendre',
  'hero.examPrepTxt': 'Préparation à l\'examen',
  'hero.aITutorTxt': 'Tuteur IA',
  'AI.toolTip': 'Posez-moi toutes vos questions en rapport avec votre livre électronique',
  'hero.studyExamPrepAllYourCourses': 'Préparation aux études pour tous vos cours',
  'header.qrCode.subHeaderTxt': 'Utilisez ce code QR pour vous connecter rapidement et en toute sécurité à l’application Pearson+ sur votre appareil mobile.',
  'header.qrCode.dontHaveApp': 'Vous n’avez pas l’application ?',
  'header.qrCode.footerTxt': 'En scannant ce code, vous serez redirigé vers l’App Store ou Google Play. Une fois l’application téléchargée, connectez-vous en scannant à nouveau le code.',
  'header.qrCode.errorMsg': 'Le code QR n’a pas été chargé. Veuillez fermer et réessayer.',
  'hero.yourETextbook': 'Votre livre électronique',
  'onboard.addCourseWithEtextBundle': 'Ajouter un cours via Préparation aux études',
  'onboard.disableTooltipText': 'Tous les cours de Préparation aux études ont été ajoutés !',
  'subscriptionstatus.bundlecta': 'Accéder à Préparation aux études',
  'subscriptionstatus.nonbundlecta': 'Accéder à Préparation aux études',
  'channel.genericBundle': 'Utilisez votre Préparation aux études pour obtenir de l’aide dans vos autres cours.',
  'channel.relatedBundle': 'Utilisez également votre Préparation aux études pour obtenir de l’aide dans vos autres cours',
  'onboard.courseAdded': 'Cours ajouté !',
  'hero.flashcards': 'Flashcards',
  'relatedChannelCard.title': 'Enrichissez vos connaissances avec ces ressources connexes',
  'relatedChannelCard.badgeText': 'Préparation aux études connexes',
  'sessionInactivity.title': 'Êtes-vous encore là ?',
  'sessionInactivity.description': 'Votre session expirera dans <b>%TIMER%</b> pour cause d’inactivité.<br/>Souhaitez-vous maintenir la connexion ?',
  'sessionInactivity.keepMeSignIn': 'Maintenir la connexion',
  'sessionInactivity.signOut': 'Se déconnecter',
  'sessionTimeout.title': 'Session expirée',
  'sessionTimeout.description': 'Votre session a expiré pour cause d’inactivité.',
  'print.qrCode.header': 'Utilisez ces codes QR pour ouvrir l’application Pearson+ sur votre appareil mobile.',
  'print.qrCode.footer': 'En scannant ce code, vous serez redirigé vers l’App Store ou Google Play. Une fois l’application installée, connectez-vous pour télécharger votre titre et y accéder.',
  'hero.nestest.title': 'Préparez votre examen de certification de professeur',
  'hero.nestest.subTitle': 'Les utilisateurs de Pearson+ peuvent désormais accéder à des cours de préparation et des tests d’entraînement alignés sur les référentiels nationaux pour préparer leurs examens de certification d’enseignant.',
  'hero.channelAI.title': 'Besoin d’aide ? Tuteur IA est là pour vous.',
  'hero.channelAI.desc': 'Posez une question et obtenez une aide aux devoirs étape par étape, des recommandations d’étude et bien plus encore : une aide personnalisée à tout moment.',
  'hero.channelAI.action': 'Demandez à Tuteur IA',
  'new': 'Nouveau !',
  'hero.practice.numOfUsers': 'Cette section comporte <b>{practice_num_of_users}</b> exercices pratiques.',
  'hero.practice.cta': 'S’entraîner maintenant',
  'hero.practice.title': 'Problème pratique',
  'diagnostics.errorMsg': 'Le diagnostic n’a pas été chargé. Veuillez fermer et réessayer.',
  'qrcode.title': 'Commencez à étudier où que vous soyez',
  'qrcode.subtitle': 'Apprenez où et quand vous voulez avec l’application mobile Pearson+. Téléchargez-la maintenant et profitez d’une expérience d’apprentissage fluide.',
  'qrcode.detailsv1': 'Avec l’application Pearson+, vous pouvez utiliser ce code QR pour reprendre là où vous vous étiez arrêté. Recherchez dans votre livre, étudiez avec des cartes-mémoires, regardez des leçons vidéo et plus encore, où que vous soyez.',
  'qrcode.detailsv2': 'Scannez ce code QR chaque fois que vous souhaitez vous connecter rapidement et reprendre exactement là où vous vous étiez arrêté.',
  'qrcode.details': 'Avec l’application Pearson+, vous pouvez utiliser ce code QR pour reprendre là où vous vous étiez arrêté.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Apprenez où et quand vous voulez avec l’application mobile Pearson+. Téléchargez-la maintenant et profitez d’une expérience d’apprentissage fluide.',
  'install': 'Install',
  'header.menu.createCourse': 'Nouveau cours',
  'header.dropdown.courses': 'Cours',
  'header.dropdown.recentlyViewed': 'Consulté récemment',
  'header.dropdown.viewAll': 'Voir tous les cours',
  'aet.courseHeader.inviteStudents': 'Inviter des étudiants',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Invitez les étudiants à accéder à cet eTextbook en copiant l’adresse du lien ou les instructions ci-dessous dans votre e-mail ou votre programme.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Adresse du lien',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Copier le lien',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instructions avec l’adresse du lien',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Copier les instructions',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'It\'s time to access {bookTitle} the eTextbook for {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'When you\'re ready, access your eTextbook at: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Vous serez invité(e) à vous connecter avec votre compte Pearson existant. Si vous n’avez pas de compte Pearson, vous pourrez en créer un.  ',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Need help? ',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Date de début :',
  'aet.courseHeader.endDate': 'Date de fin :',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format :',
  'aet.home.manageroster': 'Gérer la liste des étudiants',
  'aet.home.managegradesync': 'Gérer la synchronisation des notes',
  'aet.home.copycourse': 'Copier le cours',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.instructorCourse.tabs.current': 'Actuel',
  'aet.instructorCourse.tabs.past': 'Passé',
  'aet.instructorCourse.tabs.courseSettings': 'Paramètres du cours',
  'aet.instructorCourse.tabs.manageRoster': 'Gérer la liste des étudiants',
  'aet.instructorCourse.currentCourses.title': 'Cours actuels',
  'aet.instructorCourse.pastCourses.title': 'Cours passés',
  'aet.instructorCourse.createOrCopy.title': 'Créer ou copier un cours',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Copiez le cours d’un autre enseignant ou créez-en un nouveau',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Copier le cours d’un autre enseignant',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Saisissez l’ID du cours pour trouver le cours que vous souhaitez copier.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'ID du cours',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Saisir l’ID du cours',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Vous avez recherché',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Créer un nouveau cours à partir du catalogue',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Recherchez par titre, auteur, ISBN ou mots-clés de matière.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Rechercher...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Afficher plus',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Afficher moins',
  'aet.instructorCourse.cancel': 'ANNULER',
  'aet.instructorCourse.loading': 'En cours de chargement...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Synchronisation des notes',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Gérer la synchronisation des notes',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Nom du cours',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Sans titre',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Nom de la section',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Sans titre',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Établissement',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'L’établissement est requis',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Une erreur s’est produite. Veuillez réessayer.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Aucun résultat trouvé',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another Institution',
  'aet.instructorCourse.courseForm.startDateLabel': 'Date de début du cours',
  'aet.instructorCourse.courseForm.endDateLabel': 'Date de fin du cours',
  'aet.instructorCourse.courseForm.datePlaceholder': 'jj/mm/aa',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Autoriser d’autres personnes à copier ce cours',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Partagez ce code avec les enseignants qui souhaitent copier ce cours',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Copier le code',
  'aet.instructorCourse.courseForm.optionalSuffix': '(facultatif)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Le formulaire contient des erreurs de validation',
  'aet.instructorCourse.courseForm.submitContinue': 'Continuer',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Enregistrement…',
  'aet.instructorCourse.courseForm.submitError': 'Nous n’avons pas pu créer votre cours. Veuillez réessayer.',
  'aet.instructorCourse.courseForm.submitEditError': 'Nous n’avons pas pu enregistrer vos modifications. Veuillez réessayer.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Enregistrer les modifications',
  'aet.instructorCourse.courseForm.materialsHeader': 'Supports de cours',
  'aet.instructorCourse.courseForm.resolveError': 'Nous n’avons pas pu charger les supports de cours. Veuillez réessayer.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Dernière révision',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Recherches récentes',
  'aet.instructorCourse.coursesSort.aToZ': 'A à Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z à A',
  'aet.instructorCourse.manageRoster.column.name': 'Nom',
  'aet.instructorCourse.manageRoster.column.role': 'Rôle',
  'aet.instructorCourse.manageRoster.column.email': 'Email',
  'aet.instructorCourse.manageRoster.column.status': 'Statut',
  'aet.instructorCourse.manageRoster.enrolledDate': 'Enrolled {date}',
  'aet.instructorCourse.manageRoster.notAvailable': '--',
  'aet.instructorCourse.roster.role.student': 'Étudiant',
  'aet.instructorCourse.roster.role.ta': 'Assistant d’enseignement',
  'aet.instructorCourse.roster.role.instructor': 'Enseignant',
  'aet.instructorCourse.roster.status.active': 'Actif(ve)',
  'aet.instructorCourse.roster.status.inactive': 'Inactif(ve)',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Tous les membres',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Étudiants actifs',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Étudiants inactifs',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Assistant d’enseignement',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Enseignant',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Auteur :',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN :',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Date de création du cours :',
  'aet.instructorCourse.noCoursesFound': 'Aucun cours trouvé',
  'aet.instructorCourse.backButton': 'Retour',
  'aet.instructorCourse.selectCourse': 'Sélectionner un cours',
  'aet.home.linkedToLms': 'Lié au LMS',
  'aet.instructorCourse.courseForm.title.create': 'Créer un cours',
  'aet.instructorCourse.courseForm.title.copy': 'Copier le cours',
  'aet.instructorCourse.courseForm.title.edit': 'Informations sur le cours',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.title': 'Devoirs',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.content': 'Contenu du devoir',
  'aet.instructorCourse.courseForm.copiedContentAccordion.assignments.dueDates': 'Dates d’échéance des devoirs',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.title': 'Surlignages et notes',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.highlightColor': 'Couleur de surlignage',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.noteText': 'Texte de la note',
  'aet.instructorCourse.courseForm.copiedContentAccordion.highlightsAndNotes.sharedStatus': 'Statut de partage',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.title': 'Liste des étudiants et engagement',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.studentNames': 'Noms des étudiants',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.emailAddresses': 'Adresses e-mail',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.enrollments': 'Inscriptions',
  'aet.instructorCourse.courseForm.copiedContentAccordion.studentRosterAndEngagement.completionAndInsights': 'Achèvement et analyses',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Paramètres',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.aiToolEnablement': 'AI Tool enablement',
  'aet.instructorCourse.courseForm.copyAccordionTitle': 'Show what’s copied',
  'aet.instructorCourse.courseForm.copyAccordionSubTitle': 'Données copiées',
  'aet.studentRoster.manageStudentRosterButton': 'Gérer la liste des étudiants',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.assignments.exportStudentProgressButton': 'Exporter la progression des étudiants',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Statut :',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Inscrit :',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Rôle :',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Promote  {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'En tant qu’assistant d’enseignement, cette personne pourra voir la progression et les performances de tous les étudiants de cette classe.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'Elle pourra également gérer les étudiants et les devoirs, mais ne pourra pas supprimer la classe.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Promouvoir au rôle d’assistant d’enseignement',
  'aet.home.manageRoster.searchPlaceholder': 'Rechercher un étudiant',
  'aet.home.manageRoster.inactivateButtonLabel': 'Désactiver les étudiants sélectionnés',
  'aet.home.manageRoster.FilterLabel': 'Show',
  'aet.home.manageRoster.updatingMessage': 'Mise à jour de la liste des étudiants... Cela peut prendre quelques minutes.',
  'aet.home.courses.search.searchPlaceHolder': 'Rechercher dans vos cours',
  'aet.courses.emptyStateDescription': 'Commencez à créer votre cours en choisissant une option ci-dessous.',
  'nativePromoBanner.continueInBrowser': 'Continuer dans le navigateur',
  'globalnav.tooltip.hideNavText': 'Masquer la navigation',
  'globalnav.tooltip.showNavText': 'Afficher la navigation',
  'aet.syllabus.progressTitle': 'Extraction en cours...',
  'aet.syllabus.progressDesc': 'Veuillez patienter pendant le traitement de votre programme.',
  'aet.syllabus.uploadInputLabel': 'Glissez-déposez les fichiers ou cliquez pour les charger',
  'aet.syllabus.uploadSyllabusTabLabel': 'Télécharger le programme',
  'aet.syllabus.dateAdjusterTabLabel': 'Ajusteur de dates',
  'aet.syllabus.addManuallyTabLabel': 'Ajouter manuellement',
  'aet.syllabus.addEditLaterText': 'Vous pouvez toujours ajouter et modifier les devoirs ultérieurement.',
  'aet.syllabus.editAssignmentLabel': 'Modifier le devoir',
  'aet.syllabus.addAssignmentLabel': 'Ajouter un devoir',
  'aet.syllabus.assignmentTitleLabel': 'Titre du devoir',
  'aet.syllabus.dueDateLabel': 'Date d’échéance',
  'aet.syllabus.editDueDateLabel': 'Modifier la date d’échéance',
  'aet.syllabus.chaptersCoveredLabel': 'Sélectionnez les chapitres ou sections à couvrir.',
  'aet.syllabus.updateCtaLabel': 'Mettre à jour le devoir',
  'aet.syllabus.addCtaLabel': 'Ajouter un devoir',
  'aet.syllabus.uploadLabel': 'Télécharger',
  'aet.syllabus.confirmLabel': 'Confirmer',
  'aet.syllabus.updateDatesLabel': 'Mettre à jour la date',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Your due date was updated. Review it, then publish.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Your chapter/section information was updated. Review it, then publish.',
  'aet.syllabus.unassignedCoverageStatus': 'Some chapters are not assigned yet. Assign them before you publish.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.deleteAssignmentTitle': 'Supprimer le devoir ?',
  'aet.deleteAssignmentTitleMultiple': 'Supprimer les devoirs ?',
  'aet.deleteAssignmentWarning': 'Cette action est irréversible, et toutes les soumissions ainsi que les données des étudiants associées ne seront plus visibles.',
  'aet.deleteAssignmentKeepCTA': 'Conserver le devoir',
  'aet.deleteAssignmentDeleteCTA': 'SUPPRIMER',
  'aet.assignments.loadingAsset': 'Chargement de la ressource...',
  'aet.assignments.allCaughtUpDescription': 'Aucun devoir à rendre cette semaine.',
  'aet.assignments.progressTitle': 'Progression',
  'aet.assignments.performanceTitle': 'Niveau de confiance',
  'aet.assignments.completionTitle': 'Achèvement',
  'aet.assignments.statusTitle': 'Statut',
  'aet.assignments.addTooltip': 'Ajouter un devoir',
  'aet.assignments.deleteTooltip': 'Supprimer les devoirs sélectionnés',
  'aet.assignments.selectToDeleteLabel': 'Mode de sélection et suppression',
  'aet.assignments.bulkEditTooltip': 'Modifier plusieurs devoirs à la fois',
  'aet.assignments.title': 'Devoirs',
  'aet.assignments.assignmentTitle': 'Devoir',
  'aet.assignments.dueDate': 'Date d’échéance',
  'aet.tabular.searchPlaceholder.assignments': 'Rechercher des devoirs',
  'aet.tabular.searchPlaceholder.students': 'Rechercher des étudiants',
  'aet.tabular.searchPlaceholder.questions': 'Rechercher des questions',
  'aet.assignemnts.columnDueDateInfoTooltip': 'Un ou plusieurs étudiants bénéficient d’une extension de date d’échéance pour tous les devoirs',
  'aet.assignemnts.singleDueDateInfoTooltip': 'Un ou plusieurs étudiants bénéficient d’une extension de date d’échéance pour ce devoir',
  'aet.assignemnts.masterDueDateInfoTooltip': 'Des extensions de date d’échéance ont été accordées à un ou plusieurs étudiants. Reportez-vous à l’icône Info pour identifier ces devoirs.',
  'aet.home.loading': 'En cours de chargement...',
  'aet.home.errorFetchingAssignments': 'Erreur lors du chargement des devoirs',
  'aet.home.dueThisWeekTitle': 'À rendre cette semaine',
  'aet.home.allCaughtUpTitle': 'Vous êtes à jour !',
  'aet.home.allCaughtUpDescription': 'Aucun devoir à rendre cette semaine.',
  'aet.home.suggestedRemediationTitle': 'Révision suggérée par Préparation aux études',
  'aet.home.noSuggestedRemediationTitle': 'Aucune révision recommandée',
  'aet.home.noSuggestedRemediationDescription': 'Revenez après votre prochain devoir.',
  'aet.home.assignmentIncludesTitle': 'Le devoir inclut',
  'aet.home.sectionsLabel': 'Chapitre(s)',
  'aet.home.questionsCount': '{count} questions',
  'aet.home.dueLabel': 'À rendre le : {dueDate}',
  'aet.home.due': 'À rendre :',
  'aet.home.progressCompletedLabel': 'Terminé',
  'aet.home.progressCompletedPastDueLabel': 'Travail en retard terminé',
  'aet.home.progressInProgressLabel': 'En cours',
  'aet.home.progressNotStartedLabel': 'Non commencé',
  'aet.home.progressCountOfTotal': '{count} sur {total}',
  'aet.home.NotAttemptedLabel': 'Non tenté',
  'aet.home.questionsTotalLabel': 'Nombre total de questions',
  'aet.home.progressCompletedOnTimeLabel': 'Terminé à temps',
  'aet.home.segmentGreatLabel': 'Excellent',
  'aet.home.segmentGettingThereLabel': 'OK',
  'aet.home.segmentNeedsReviewLabel': 'À améliorer',
  'aet.home.segmentOkayLabel': 'OK',
  'aet.home.editAssignmentTooltip': 'Modifier le devoir',
  'aet.home.deleteAssignmentTooltip': 'Supprimer le devoir',
  'aet.home.viewDetailsButton': 'Afficher les détails',
  'aet.home.viewAsStudentButton': 'Afficher en tant qu’étudiant',
  'aet.home.welcomeButtonText': 'Commencer →',
  'aet.review.emptyStateTitle': 'Rien à réviser',
  'aet.review.emptyStateDescription': 'Revenez après votre prochain devoir.',
  'aet.dashboard.tabs.upNext': 'À venir',
  'aet.dashboard.tabs.welcome': 'Bienvenue',
  'aet.dashboard.tabs.assignments': 'Devoirs',
  'aet.dashboard.tabs.review': 'Révision',
  'aet.dashboard.tabs.studentRoster': 'Étudiants',
  'aet.dashboard.classSchedule': 'Programme de la classe:',
  'aet.syllabus.dueTimeLabel': 'Heure d’échéance',
  'hero.accessEducatorGuides': 'Accéder aux guides enseignants',
  'aet.assignment.save': 'Enregistrer',
  'aet.assignment.saveAndAdd': 'Enregistrer et en ajouter un autre',
  'aet.assignment.delete': 'SUPPRIMER',
  'aet.assignment.saveAndClose': 'Enregistrer et fermer',
  'aet.studentRoster.title': 'Étudiants',
  'aet.studentRoster.titlev1': 'Étudiant',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Dates d’échéance',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standard',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 jours',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 jours',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 jours',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 semaine',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 semaines',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Dernier jour de cours',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} devoirs mis à jour',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': 'Les devoirs en retard n’ont pas pu être mis à jour automatiquement. Modifiez chaque devoir pour définir une nouvelle date d’échéance.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'Impossible de mettre à jour les dates d’échéance',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'Tous les devoirs sont en retard et n’ont pas pu être mis à jour automatiquement. Modifiez chaque devoir pour définir une nouvelle date d’échéance.',
  'aet.bulkEdit.bulkSplitInstruction': 'Nous répartirons vos devoirs de manière équilibrée.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Date d’échéance du premier devoir',
  'aet.bulkEdit.lastAssignmentDue': 'Date d’échéance du dernier devoir',
  'aet.bulkEdit.assignmentsDueDays': 'Quels jours souhaitez-vous pour les dates de rendu des devoirs ?',
  'aet.bulkEdit.addEditLaterText': 'Nous utilisons l’IA pour créer des devoirs. Vous pouvez toujours ajouter et modifier les devoirs ensuite.',
  'aet.bulkEdit.monday': 'Lundi',
  'aet.bulkEdit.tuesday': 'Mardi',
  'aet.bulkEdit.wednesday': 'Mercredi',
  'aet.bulkEdit.thursday': 'Jeudi',
  'aet.bulkEdit.friday': 'Vendredi',
  'aet.bulkEdit.saturday': 'Samedi',
  'aet.bulkEdit.sunday': 'Dimanche',
  'aet.toast.assignmentCreated.title': 'Devoir créé !',
  'aet.toast.assignmentCreated.single': 'Il a été automatiquement nommé {assignmentTitle}',
  'aet.toast.assignmentCreated.multiple': '{count} les devoirs ont été créés',
  'aet.toast.assignmentUpdated.title': 'Mise à jour réussie.',
  'aet.toast.assignmentUpdated.single': '{assignmentTitle} a été mis à jour',
  'aet.toast.assignmentUpdated.multiple': '{count} devoirs ont été mis à jour',
  'aet.toast.viewAssignment': 'Vor le devoir',
  'aet.toast.viewAssignments': 'Afficher les devoirs',
  'aet.welcome.title': 'Votre eTextbook Pearson est maintenant lié à votre cours LMS',
  'aet.welcome.LMSAccounTitle': 'Explorer les analyses',
  'aet.welcome.LMSAccounDescription': 'Voyez précisément sur quels sujets votre classe rencontre des difficultés.',
  'aet.welcome.createAssignmentsTitle': 'Créer des devoirs',
  'aet.welcome.createAssignmentsDescription': 'Attribuez des chapitres manuellement ou en téléchargeant votre programme.',
  'aet.welcome.progressViewTitle': 'Suivre les performances dans votre LMS',
  'aet.welcome.progressViewDescription': 'Choisir les paramètres de synchronisation des notes dans votre cours LMS',
  'aet.assignmentDetails.noAssignmentFound': 'Aucun devoir trouvé',
  'aet.assignments.loadingErrorTitle': 'Impossible de charger le devoir pour le moment',
  'aet.assignments.loadingErrorDescription': 'Essayez d’actualiser ou revenez plus tard.',
  'aet.assignmentStudentDetails.noDataFound': 'Aucune donnée pour le moment',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Aucun étudiant inscrit',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Les étudiants rejoindront votre classe lorsqu’ils achèteront le livre électronique.',
  'aet.home.editAssignmentTooltipDisabled': 'Modification impossible : travail étudiant en cours',
  'aet.home.deleteAssignmentTooltipDisabled': 'Suppression impossible : travail étudiant en cours',
  'aet.home.StudentDetails.questions': 'Questions',
  'aet.home.StudentDetails.attempts': 'Tentatives',
  'aet.home.StudentDetails.comprehension': 'Niveau de confiance',
  'hero.titleInfo.tooltip': 'Informations sur les titres',
  'aet.home.publishAssignments': 'Publier tous les devoirs',
  'aet.dashboard.footer': 'Certains contenus sont créés à l\'aide de l’IA à partir des supports d’apprentissage de Pearson. Bien que Pearson dispose d’un processus pour valider les résultats, l’IA générative peut encore générer des informations inexactes sur des personnes, des lieux ou des faits.',
  'aet.home.bulkEditTitle': 'Modifier plusieurs devoirs à la fois',
  'aet.home.bulkEditSubtitle': 'Apportez vos modifications à votre programme, puis téléchargez-le à nouveau ici. Vos devoirs et dates d’échéance seront mis à jour en conséquence.',
  'aet.home.createAssignmentTitle': 'Créer des devoirs',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Inclus dans un autre devoir',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Certaines sections sont incluses dans un autre devoir',
  'aet.welcome.welcome.Title': 'Bienvenue !',
  'aet.home.student.roaster.ProgressTitle': 'Achèvement total',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Revenez lorsque les étudiants auront commencé le devoir.',
  'aet.home.whatDueThisWeekTitle': 'Voici ce qui est à rendre cette semaine',
  'aet.assignments.edit.errorTitle': '{count} les devoirs contiennent des erreurs',
  'aet.assignments.edit.errorSubTitle': 'Les devoirs comportant des erreurs ne peuvent pas être publiés. Modifiez-les ou publiez sans eux.',
  'aet.assignments.edit.publishAnyway': 'Publier quand même',
  'aet.assignments.edit.editAssignments': 'Modifier les devoirs',
  'aet.assignments.edit.validationInfoToolTip': 'Modifier le devoir pour corriger les erreurs',
  'aet.assignments.error.assignmentCreated.title': 'Tous les devoirs contiennent des erreurs',
  'aet.assignments.error.assignmentCreated.description': 'Les devoirs comportant des erreurs ne peuvent pas être publiés. Modifiez-les ou essayez un autre programme.',
  'aet.assignments.error.uploadSyllabus': 'Télécharger le programme',
  'aet.assignments.error.editAssignments': 'Modifier les devoirs',
  'aet.mondly.title': 'Langues',
  'aet.studentRoster.errorState.title': 'Liste des étudiants indisponible',
  'aet.studentRoster.errorState.description': 'Impossible de charger la liste des étudiants. Essayez d’actualiser ou revenez plus tard.',
  'aet.assignments.sectionLabel': 'section(s)',
  'aet.assignments.questionsLabel': 'question(s)',
  'aet.assignments.assignmentsLabel': 'devoir(s)',
  'aet.assignments.performanceProgressBar': 'Barre de progression des performances',
  'aet.assignments.completionProgressBar': 'Barre de progression de l’achèvement',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Êtes-vous sûr de vouloir supprimer ce devoir ?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Êtes-vous sûr de vouloir supprimer ces devoirs ?',
  'aet.home.nextAssignmentTitle': 'Prochain devoir',
  'aet.home.courseSettings': 'Paramètres du cours',
  'aet.home.pearsonETextbookResources': 'Ressources eTextbook Pearson+',
  'aet.home.etextbookInformation': 'Informations sur l’eTextbook',
  'aet.multiple.deleteAssignmentKeepCTA': 'Conserver le(s) devoir(s)',
  'aet.syllabus.processingText.header': 'Nous organisons les lectures assignées à votre classe ; cela ne prendra qu’un instant.',
  'aet.syllabus.processingText.uploading': 'Téléchargement de votre document',
  'aet.syllabus.processingText.activating': 'Activation des composants IA',
  'aet.syllabus.processingText.extracting': 'Extraction des devoirs de lecture',
  'aet.syllabus.processingText.mapping': 'Correspondance avec le contenu du manuel',
  'aet.syllabus.processingText.finishing': 'Finalisation',
  'aet.syllabus.uploadErrorMessage': 'Assurez-vous que votre fichier PDF ou .docx ne dépasse pas 10 Mo et que votre connexion Internet est stable',
  'aet.syllabus.uploadNoAssignmentsMessage': 'No reading assignments found',
  'aet.syllabus.uploadNoAssignmentsDescription': 'We could not pull reading assignments from this file. You can add them manually.',
  'aet.syllabus.uploadFailedRetryCTA': 'Réessayer',
  'aet.syllabus.selectChapterWithQuestions': 'Sélectionnez un chapitre contenant une ou plusieurs question(s).',
  'preferenceSetting.subTitle': 'Ces paramètres seront appliqués par défaut à tous les étudiants de ce cours.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'Interactions avec l’IA',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Activer l’outil d’étude IA et les résumés IA dans les résultats de recherche',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Afficher les ressources de Préparation aux études liées à ce livre',
  'aet.syllabus.footer': 'La création des devoirs est alimentée par l’IA',
  'aet.dashboard.footerDialogDeatils': 'L’IA générative est utilisée pour créer des questions de devoir à partir des supports pédagogiques de Pearson. Bien que Pearson dispose d’un processus de validation des résultats, l’IA générative peut néanmoins produire des informations inexactes concernant des personnes, des lieux ou des faits. L’IA est également utilisée pour regrouper le contenu en devoirs, en fonction du programme et/ou du planning que vous fournissez.',
  'aet.review.footer': 'Généré par l’IA',
  'aet.footerCard.dismiss': 'Ignorer',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Préparation aux études est un outil supplémentaire qui soutient l’apprentissage en proposant aux étudiants des vidéos et des exercices adaptés à ce cours.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Les étudiants dont l’offre d’accès n’inclut pas Préparation aux études peuvent être invités à s’abonner afin de continuer à utiliser les ressources de Préparation aux études.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Les étudiants ayant déjà acheté Préparation aux études ne seront pas affectés par ce paramètre.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'En savoir plus sur les avantages de Préparation aux études',
  'aet.home.viewCourseId': 'Afficher l’ID du cours',
  'aet.home.copy': 'Copier',
  'aet.home.copied': 'Copié',
  'aet.home.courseLabel': 'ID du cours :',
  'schoolInfoCard.addUniversity': 'Ajouter un établissement',
  'schoolInfoCard.title': 'Informations sur l’établissement',
  'schoolInfoCard.titleV1': 'Parlez-nous de votre cours',
  'schoolInfoCard.cta': 'Commencer',
  'schoolInfoCard.pickInstitution': 'Choisir un établissement',
  'schoolInfoCard.addUniversityTitle': 'Ajouter votre établissement',
  'schoolInfoCard.addUniversitySubtitle': 'Connaître votre établissement et votre cours nous permet de vous recommander les supports d’étude les plus utiles.',
  'schoolInfoCard.searchPlaceholder': 'Rechercher votre établissement...',
  'schoolInfoCard.skip': 'Ignorer cette étape',
  'schoolInfoCard.nextStep': 'Étape suivante',
  'schoolInfoCard.notInList': 'Mon établissement n’est pas dans la liste',
  'schoolInfoCard.noResults': 'Aucun établissement correspondant à votre recherche',
  'schoolInfoCard.noResultsHeading': 'Vous ne trouvez pas votre établissement ?',
  'schoolInfoCard.noResultsInstruction': 'Saisissez le nom complet ci-dessous',
  'schoolInfoCard.noResultsInputPlaceholder': 'Nom de l’établissement',
  'schoolInfoCard.addInstitutionLabel': 'Ajouter cet établissement',
  'aet.assignments.assignmentTitlePlaceholder': 'Saisir un titre',
  'aet.assignments.titleValidation.titleRequired': 'Le titre du devoir est requis.',
  'aet.assignments.titleValidation.titleTooLong': 'Le titre du devoir ne peut pas dépasser {0} caractères.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Le titre du devoir contient des caractères non pris en charge.',
  'aet.assignments.titleValidation.titleDuplicate': 'Le titre du devoir existe déjà',
  'aet.syllabus.timeZoneLabel': 'Fuseau horaire',
  'aet.review.reviewReadingFromAssignments': 'Relire les passages associés au devoir',
  'aet.assignments.chaptersLabel': 'chapitre(s)',
  'menu.myAccount.subTitle': 'Votre établissement s’affiche ici',
  'menu.myAccount.subTitleNotAvailable': 'Vous pourrez ajouter l’établissement ici à tout moment plus tard.',
  'schoolInfoCard.toastMessage': 'Université enregistrée',
  'aet.review.threeDotMenu.askAI': 'Poser une question à l’IA',
  'aet.home.suggestedRemediationSubtitle': 'Regardez des vidéos pertinentes et entraînez-vous pour maîtriser les sujets de votre cours.',
  'aet.home.laggedQuestionLabel': 'Questions signalées',
  'aet.home.correctAnswer': 'Bonne réponse',
  'aet.home.incorrectAnswer': 'Réponse incorrecte la plus fréquente',
  'aet.home.behaviourTrendsLabel': 'Analyses de la question',
  'aet.home.strugglingStudentsLabel': 'Étudiants en difficulté',
  'aet.home.patternsInStudensAiLabel': 'Modèles dans l’usage de l’IA par les étudiants',
  'aet.home.questionLabel': 'Question',
  'aet.home.studentAskingSimilarQuestions': 'Étudiants posant des questions similaires',
  'aet.home.assignmentDifficultQuestions': 'Questions difficiles',
  'aet.home.behaviorTrends': 'Analyses de la question',
  'aet.home.behaviors': 'Indicateurs de performance',
  'aet.home.mostDifficultTopics': 'Questions les plus difficiles',
  'aet.home.commentsFromStudentLabel': 'Commentaires des étudiants',
  'aet.home.disregard': 'Ignorer',
  'aet.home.reportAsInaccurate': 'Signaler comme inexact',
  'aet.home.Flagged': 'Signalé',
  'aet.home.reportQuestionTitle': 'Signaler la question',
  'aet.home.reportQuestionLabel': 'En quoi cette question n’allait pas ?',
  'aet.home.showComments': 'Afficher les commentaires',
  'aet.home.studentReports': 'rapports d’étudiants',
  'aet.home.placeholderText': 'Veuillez expliquer...',
  'aet.home.reportQuestion.notRelevant': 'Non pertinente',
  'aet.home.reportQuestion.notCorrect': 'Incorrecte',
  'aet.home.reportQuestion.unsafe': 'Dangereux/nocif',
  'aet.home.reportQuestion.somethingElse': 'Autre',
  'aet.home.StudentDetails.assistedByAI': 'Assisté par l’IA',
  'aet.home.strugglingStudents.emptyStateTitle': 'Aucun étudiant n’est en difficulté pour le moment',
  'aet.home.strugglingStudents.emptyStateDescription': 'Revenez plus tard.',
  'aet.home.overallStatus.excelling': 'Excellence',
  'aet.home.overallStatus.fallingBehind': 'En difficulté',
  'aet.home.overallStatus.keepingUp': 'En bonne voie',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Afficher uniquement « Questions difficiles »',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Afficher uniquement « Étudiants en difficulté »',
  'aet.home.viewQuestionInAssignment': 'Voir la question dans le devoir',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Premières tentatives incorrectes',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Plusieurs tentatives incorrectes',
  'aet.home.insightRisk.lowConfidence': 'Niveau de confiance bas',
  'aet.home.insightRisk.mediumConfidence': 'Niveau de confiance moyen',
  'aet.home.insightRisk.lowEngagement': 'Faible engagement',
  'aet.home.insightRisk.countOfStudents': '{count} étudiants sur {total}',
  'aet.home.insightRisk.na': 'S/O',
  'aet.home.strugglingStudentsHereLabel': 'Étudiants en difficulté ici',
  'aet.home.insightRisk.didNotAttempt': 'N’a pas tenté',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText'
};

export default fr;
